import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import backIcon from "./images/backk.png";
import switchIcon from "./images/switchh.png";

function SetUps() {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [usingBackCamera, setUsingBackCamera] = useState(false);
  const [userEmail, setUserEmail] = useState(null);
  const [result, setResult] = useState("");
  const [imageCount, setImageCount] = useState(1);
  const navigate = useNavigate();

  const handleBackClick = () => navigate(-1);

  const getMediaStream = async () => {
    const videoConstraints = {
      facingMode: usingBackCamera ? "environment" : "user",
    };

    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: videoConstraints,
      });
      if (videoRef.current) videoRef.current.srcObject = stream;
    } catch (err) {
      console.error("Error accessing the camera: ", err);
    }
  };

  useEffect(() => {
    getMediaStream();

    return () => {
      if (videoRef.current && videoRef.current.srcObject) {
        videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
      }
    };
  }, [usingBackCamera]);

  useEffect(() => {
    const email = sessionStorage.getItem("userEmail");
    if (!email) {
      navigate("/signin");
    } else {
      setUserEmail(email);
    }
  }, [navigate]);

  const captureFrame = () => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    const video = videoRef.current;

    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    const frameData = canvas.toDataURL("image/png").split(",")[1];

    fetch("https://www.d-rosa.ai/Capture_image", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        image_name: `Checkpoint${imageCount}`, // Save as Checkpoint1, Checkpoint2, Checkpoint3...
        image_data: `data:image/jpeg;base64,${frameData}`,
        userEmail: userEmail,
      }),
      credentials: "include",
    })
      .then((response) => response.json())
      .then((data) => setResult(data.message))
      .catch((err) => console.error("Error sending frame to backend: ", err));

    setImageCount((prevCount) => prevCount + 1);
  };

  const handleSwitchCamera = () => {
    setUsingBackCamera((prevState) => !prevState);
  };

  if (!userEmail) {
    return null;
  }

  return (
    <div
      style={{
        background: "linear-gradient(to bottom, #fff7ad, #ffa9f9)",
        minHeight: "100vh",
        padding: "20px",
        color: "#E11584",
        textAlign: "center",
      }}
    >
      <h1 style={{ color: "#E11584" }}>SetUp Screen</h1>
      {userEmail && (
        <p
          style={{
            color: "#E11584",
            fontSize: "20px",
            textAlign: "center",
            marginBottom: "20px",
          }}
        >
          Signed in as: {userEmail}
        </p>
      )}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <video ref={videoRef} width="640" height="480" autoPlay />
        <canvas
          ref={canvasRef}
          width="640"
          height="480"
          style={{ display: "none" }}
        ></canvas>
      </div>
      <div style={{ margin: "20px" }}>
        <button
          onClick={captureFrame}
          style={{
            backgroundColor: "#E11584",
            color: "white",
            padding: "10px 20px",
            border: "2px solid #E11584",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Click
        </button>
      </div>
      <button
        type="button"
        onClick={handleSwitchCamera}
        style={{
          backgroundColor: "#E11584",
          border: "none",
          cursor: "pointer",
          padding: "10px",
          borderRadius: "5px",
        }}
      >
        <img src={switchIcon} width="30" height="30" alt="Switch Camera" />
      </button>
      <br />
      <br />
      <br />
      <button onClick={handleBackClick}>
        <img src={backIcon} width="40" height="40" alt="Back" />
      </button>
      <br />
      <p style={{ color: "#E11584" }}>{result}</p>
    </div>
  );
}

export default SetUps;
